module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-18.3622d7f0.jpg";